module.exports = __webpack_public_path__ + "static/media/commit.73e1f04f.png";